import React, { ReactElement } from 'react';
import NextLink from 'next/link';
import { useRouter } from 'next/router';
import { preserveUtmParams } from '@/shared/services/analytics/utmNavigation';

type Props = React.ComponentProps<typeof NextLink>;

const UtmLink = ({ href, ...props } : Props) : ReactElement => {
    const router = useRouter();
    const origin = typeof window === 'undefined' ? 'https://bubotrans.cz' : window.location.origin;
    const currentUrl = new URL(router.asPath, origin).toString();
    const target = typeof href === 'string' ? preserveUtmParams(href, currentUrl) : href;

    return <NextLink href={target} {...props} />;
};

export default UtmLink;
